import type { EventParticipant } from '@cocoonspace/sdk-js/types/eventParticipant'
import { getDisplayName } from '@cocoonspace/shared/utils/get-display-name'
import type { PrettyPick } from '@cocoonspace/types/shared'

interface GuestAutocompleteOptionProps {
	guest: PrettyPick<EventParticipant, 'email' | 'last_name' | 'first_name'>
	onClick: (guest: EventParticipant) => void
}

export const GuestAutocompleteOption = ({
	guest,
	onClick,
}: GuestAutocompleteOptionProps) => {
	const label = getDisplayName({ ...guest })

	return (
		<button
			type='button'
			role='button'
			className='w-full rounded px-4 py-2 text-left hover:bg-slate-200/30'
			onMouseDown={(e) => e.preventDefault()}
			onClick={() => onClick(guest)}
		>
			{label}
		</button>
	)
}
